// extracted by mini-css-extract-plugin
export default {"emailConfirmPage":"style_emailConfirmPage__AZnYi","emailConfirmInner":"style_emailConfirmInner__ODIIi","successBox":"style_successBox__z8e9w"};